import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useIsPartFinderProductTypeLoading } from 'companySettings/hooks';
import { IPartFinderProductType } from 'companySettings/types';
import { Button } from 'core/components';

import { UpsertPartFinderProductType } from './UpsertPartFinderProductType';

interface IProps {
  productType?: IPartFinderProductType;
  buttonElement?: ReactElement;
}

export const UpsertPartFinderProductTypeButton = ({ productType, buttonElement }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  // One editor at a time: while one loads its product type, no other trigger can open another.
  const isProductTypeLoading = useIsPartFinderProductTypeLoading();

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
        disabled: buttonElement.props.disabled || isProductTypeLoading,
      });
    }

    return (
      <Button
        text={t('buttonLabelAddPartFinderProductType')}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
        disabled={isProductTypeLoading}
      />
    );
  }, [buttonElement, isProductTypeLoading, t]);

  return (
    <>
      {button}

      <UpsertPartFinderProductType
        productType={productType}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
